/** @format */

import { Component, Mixins, Vue } from 'vue-property-decorator';
// @ts-ignore
import listPageMixin, { createSlotComp } from '@root/common/mixins/list-page/list-page.vue';
import { payBackStatusMap, uncollectedTypesMap } from '@/types/exception-management/dictionaries';

import {
  queryOrderUncollectedRecord,
  orderUncollectedExamine,
  orderUncollectedExport
} from '@/api/exception-management/index';

import dataTransferCenter from './dataTransferCenter';
import uiConfig from './pageBootstrap.json';

@Component({
  name: 'OrderUncollectedRecord',
  components: {
    operation: createSlotComp(`
    <a-button
                :disabled="scope.record.payBackStatusName == '已补缴' && !vm.isLocalDebugMode()"
                type="link"
                size="small"
                @click="vm.showDetailDialog(scope.record, 'PAY')"
              >补缴</a-button>
    `)
  }
})
export default class OrderUncollectedRecord extends Mixins(listPageMixin) {
  // 查询条件

  //查看图片使用的表单定义
  viewImageDialogFieldsDefination = '车牌-plate 入场时间-enterTime 入场位置-enterChannelName';

  // initialTableColumnData = tableColumnData

  // 弹窗控制
  // addEditModalVisible: boolean = false
  //审核意见
  reviewDescriptionOfDialog = '';

  customPrimaryUIConfig = uiConfig;

  get dialogCancelText() {
    return 'REVIEW' == this.detailDialogType ? '未通过' : '';
  }

  // private requestHandler = {
  //   list: queryOrderUncollectedRecord,
  //   export: orderUncollectedExport,
  //   exaimine: orderUncollectedExamine,
  // }
  dataTransferCenter = dataTransferCenter;
  get customFilterParam() {
    const _self = this;
    const o = {
      adapterDataForViewModel: {
        //补缴方式 //此处数据写的地方有误，如果filter区域加一个补缴方式搜索条件，将会导致故障因为弹出层中数据模型未单独定义而用的这儿，先赶进度完了再改
        payBackWayHandler: {
          list: [],
          model: (function() {
            Vue.nextTick(() => {
              // @ts-ignore
              o.adapterDataForViewModel.payBackWayHandler.model = o.payWay;
            });
            return '';
          })(),
          onChange: (value: string) => {
            o.adapterDataForViewModel.payBackWayHandler.model = value;
            // this.filterParam.payWay = value
          }
        },
        //补缴状态
        // payBackStatusMap,
        // payBackStatusHandler: PayBackStatusMap,
        //应收未收类型
        // uncollectedTypesMap,

        plateModel: false
      }
    };
    return o;
  }

  //filter-param

  // }.call(this)

  // onTableFilterClearCallback = (filterParam: any) => (filterParam.adapterDataForViewModel.plateModel = true)

  onDetailDialogConfirm = (nodeName: any) => this.onDetailDialogCancel(nodeName, '01');

  mounted() {
    this.log('list-page--:', this.listPage);
  }

  async onDetailDialogCancel(nodeName: any, reviewStatus = '00') {
    //如果是取消直接关闭弹出层而不用调接口了
    if (reviewStatus == '00') {
      // @ts-ignore
      this.$refs.detailDialog.hideDialog();
      return false;
    }
    if ('PAY' == this.detailDialogType && nodeName == 'BUTTON') {
      const row = this.getBasicInfoByDetailModel();
      console.log(row);
      const p = {
        // id: row.pkLiftId,
        id: row.pkUnCollectedId,
        parkId: row.parkId,
        orderId: row.orderId,
        // reviewStatus: reviewStatus,
        // reviewDescription: this.reviewDescriptionOfDialog,

        payBackAmount: row.uncollectedAmount,
        payBackWay: this.filterParam.adapterDataForViewModel.payBackWayHandler.model
      };

      console.log('补缴接口req param-:', p);
      await orderUncollectedExamine(p);
      // await this.requestHandler.exaimine(p)
      this.$message.success('补缴成功');
      // @ts-ignore
      this.$refs.detailDialog.hideDialog();
      this.fetchTableData();
    } else {
      // @ts-ignore
      this.$refs.detailDialog.hideDialog();
    }
  }
}
